'use client';
import Link from '@/components/Link';
import Image from 'next/image';
import styles from './logoLink.module.scss';
import { TLogoLinkProps } from './LogoLink.types';

export default function LogoLink({
  onClick,
  isDarkSection = false
}: Readonly<TLogoLinkProps>) {
  return (
    <Link onClick={() => onClick?.()} href="/">
      <Image
        priority
        loading="eager"
        src="/logo.svg"
        width={108}
        height={24}
        alt="Baseline Logo"
        className={isDarkSection ? styles.logoDark : undefined}
      />
    </Link>
  );
}
